import { render, staticRenderFns } from "./SaleBase.vue?vue&type=template&id=3396d4d0&scoped=true&"
import script from "./SaleBase.vue?vue&type=script&lang=js&"
export * from "./SaleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396d4d0",
  null
  
)

export default component.exports